import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-screen px-10" }
const _hoisted_2 = { class: "flex flex-col gap-2 w-96" }
const _hoisted_3 = { class: "flex flex-col gap-2 w-96" }
const _hoisted_4 = { key: 0 }

import { onMounted, ref } from 'vue';
import axios from 'axios';
import UserService from '@/service/user.service';
import retry from 'async-retry'; // optional but recommended

// Reactive variables for title and message

export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationManager',
  setup(__props) {

const title = ref<string>('');
const message = ref<string>('');
const pushTokens = ref<Record<string, string>[]>([]);

// Error handling
const error = ref<string | null>(null);

const sendNotification = async (expoPushToken: string): Promise<void> => {
  try {
    await retry(
      async () => {
        await axios.post('http://localhost:3000/send-notification', {
          title: title.value,
          message: message.value,
          expoPushToken,
        });
      },
      {
        retries: 2,
        minTimeout: 500,
        factor: 2,
      },
    );
    console.log(`✅ Sent to ${expoPushToken}`);
  } catch (err) {
    console.error(`❌ Failed to send to ${expoPushToken}`, err);
  }
};

const sendNotificationsToAllUsers = async () => {
  const tokens = pushTokens.value.map((t) => t.token);
  const CONCURRENCY_LIMIT = 10;

  // eslint-disable-next-line no-promise-executor-return
  const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

  for (let i = 0; i < tokens.length; i += CONCURRENCY_LIMIT) {
    const chunk = tokens.slice(i, i + CONCURRENCY_LIMIT);
    // eslint-disable-next-line no-await-in-loop
    await Promise.all(chunk.map(sendNotification));
    // eslint-disable-next-line no-await-in-loop
    await delay(100); // throttle to avoid hitting server too hard
  }

  console.log('🎉 All notifications processed');
};

onMounted(async () => {
  pushTokens.value = await UserService.getUserPushTokens();
  console.log(`Total push tokens: ${pushTokens.value.length}`);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "flex flex-col border border-neutral-600 rounded-xl items-center justify-center",
      onSubmit: _withModifiers(sendNotificationsToAllUsers, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("label", { for: "title" }, "Title", -1)),
        _withDirectives(_createElementVNode("input", {
          id: "title",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
          class: "rounded-lg border border-black",
          type: "text",
          placeholder: "Enter title"
        }, null, 512), [
          [_vModelText, title.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("label", { for: "message" }, "Message", -1)),
        _withDirectives(_createElementVNode("textarea", {
          id: "message",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((message).value = $event)),
          class: "rounded-lg border border-black",
          placeholder: "Enter message"
        }, null, 512), [
          [_vModelText, message.value]
        ])
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("button", {
        type: "submit",
        class: "w-96 py-3 bg-blue-900 text-white text-center rounded-xl"
      }, " Send ", -1))
    ], 32),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})